<section class="content">
    <div class="content-block">
        <div class="card" [ngBusy]="{ busy: busyGet, message: 'Veuillez patienter ...', backdrop: false }">

            <!-- Filtres -->
            <div class="p-2 border-bottom">
                <div class="d-flex flex-wrap align-items-flex-end" style="gap:8px">

                    <div style="min-width:200px">
                        <label class="small mb-0">Rechercher</label>
                        <input [(ngModel)]="searchKey" class="form-control form-control-sm" placeholder="Rechercher ..."
                            (keyup)="currentPage = 0; getItems()" />
                    </div>

                    <div style="min-width:120px">
                        <label class="small mb-0">Date début</label>
                        <input type="text" class="form-control form-control-sm" placeholder="dd/mm/yyyy"
                            autocomplete="off" bsDatepicker
                            [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', containerClass: 'theme-dark-blue' }"
                            [(ngModel)]="dateDebut" />
                    </div>

                    <div style="min-width:120px">
                        <label class="small mb-0">Date fin</label>
                        <input type="text" class="form-control form-control-sm" placeholder="dd/mm/yyyy"
                            autocomplete="off" bsDatepicker
                            [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', containerClass: 'theme-dark-blue' }"
                            [(ngModel)]="dateFin" />
                    </div>

                    <div style="min-width:180px">
                        <label class="small mb-0">Type de document</label>
                        <select class="form-control form-control-sm" [(ngModel)]="filterDescription">
                            <option value="">-- Tous --</option>
                            <option *ngFor="let t of documentTypes" [value]="t.value">{{ t.libelle }}</option>
                        </select>
                    </div>

                    <div style="min-width:110px">
                        <label class="small mb-0">Format</label>
                        <select class="form-control form-control-sm" [(ngModel)]="filterFormat">
                            <option value="">-- Tous --</option>
                            <option value="pdf">PDF</option>
                            <option value="excel">Excel</option>
                        </select>
                    </div>

                    <div style="padding-top:18px; display:flex; gap:6px">
                        <button class="btn btn-sm btn-info" (click)="currentPage = 0; getItems()">
                            <i class="fa fa-search mr-1"></i> Rechercher
                        </button>
                        <button class="btn btn-sm btn-secondary" (click)="resetFiltres()" title="Réinitialiser">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>

                    <span class="ml-auto text-muted small" style="padding-top:20px">Total : {{ totalItems }}</span>
                </div>
            </div>

            <!-- Tableau -->
            <div class="body table-responsive">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr class="custom-table-head">
                            <th style="width:40px">#</th>
                            <th>Libellé</th>
                            <th>Type</th>
                            <th>Format</th>
                            <th>Utilisateur</th>
                            <th>Date</th>
                            <th class="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items; let i = index">
                            <td class="text-muted">{{ i + 1 }}</td>
                            <td>{{ item.libelle || '—' }}</td>
                            <td>
                                <span class="dc-badge dc-badge-info" style="font-size:0.7rem">
                                    {{ getDocumentTypeLabel(item.description) }}
                                </span>
                            </td>
                            <td>
                                <span *ngIf="isExcel(item)" class="dc-badge dc-badge-success" style="font-size:0.7rem">
                                    <i class="fa fa-file-excel mr-1"></i>Excel
                                </span>
                                <span *ngIf="!isExcel(item)" class="dc-badge dc-badge-danger" style="font-size:0.7rem">
                                    <i class="fa fa-file-pdf mr-1"></i>PDF
                                </span>
                            </td>
                            <td>{{ item.created_by_login || '—' }}</td>
                            <td>{{ item.created_at | dateTimeFormat }}</td>
                            <td class="text-center" style="white-space:nowrap">
                                <a class="btn btn-sm btn-outline-info mr-1" title="Voir le document"
                                    [href]="item.image_url" target="_blank">
                                    <i class="fa fa-eye"></i>
                                </a>
                                <!-- <button class="btn btn-sm btn-outline-danger" title="Supprimer"
                  (click)="confirmDelete(item)">
                  <i class="fa fa-trash"></i>
                </button> -->
                            </td>
                        </tr>
                        <tr *ngIf="!items || items.length === 0">
                            <td colspan="7" class="text-center text-muted" style="padding:40px">
                                <i class="fa fa-inbox fa-2x mb-2 d-block"></i>
                                Aucun document trouvé
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- Pagination -->
                <div class="row pagination-part mt-2" *ngIf="items && items.length > 0">
                    <div class="col-md-9 text-center">
                        <pagination [maxSize]="5" [boundaryLinks]="true" [itemsPerPage]="itemsPerPage"
                            [totalItems]="totalItems" [(ngModel)]="currentPage" class="pagination-sm"
                            previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
                            (pageChanged)="pageChanged($event)">
                        </pagination>
                    </div>
                    <div class="col-md-3">
                        <div class="paginator-per-page">
                            <app-element-by-page-paginator (paginationChange)="changePaginationSize($event)"
                                [defaultItemPerPage]="itemsPerPage">
                            </app-element-by-page-paginator>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>